"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Trigger = void 0;
var _react = _interopRequireDefault(require("react"));
var Trigger = function Trigger(_ref) {
  var onOpen = _ref.onOpen,
    triggerObject = _ref.triggerObject;
  if (!triggerObject) {
    return null;
  }
  return /*#__PURE__*/_react["default"].cloneElement(triggerObject, {
    onClick: onOpen,
    className: 'cds-Modal-Trigger'
  });
};
exports.Trigger = Trigger;